import { AssetClass } from '@/entities/assets'

import { TRANSACTION_TYPE } from '@/entities/transactions/utils/const'

import { WizardValues } from '../utils/types'
import { createHolding, ensureOwnerAccount, ensureTagIds } from '../utils/create'

import { LoanDirection } from './schema'

/**
 * One loan, owed from or to the account the ownership step named — which of
 * the two depends on `direction`, the one field this flow asks before it asks
 * anything else. Borrowed posts a liability; lent posts a plain position, the
 * same shape a receivable already has everywhere else in the app.
 *
 * The type comes off the values rather than from a constant here: the flow
 * fixes it in its definition, and reading it back is what keeps the summary's
 * claim and the created record the same fact.
 */
export const create = async (values: WizardValues): Promise<AssetClass[]> => {
  const tagIds = await ensureTagIds(values.tags)
  const accountId = await ensureOwnerAccount(values)

  const transactionType = values.direction === LoanDirection.BORROWED
    ? TRANSACTION_TYPE.ADD_LIABILITY
    : TRANSACTION_TYPE.ADD_POSITION

  const loan = await createHolding({
    accountId,
    transactionType,
    name: values.assetName,
    type: values.assetType,
    currency: values.currency,
    description: values.description,
    amount: values.amount,
    date: values.date,
    tagIds,
  })

  return [loan]
}
